import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import MyTable from 'v2/components/Shared/MyTable';
import MyTableBody from 'v2/components/Shared/MyTable/MyTableBody';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableHeader from 'v2/components/Shared/MyTable/MyTableHeader';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import helpService from 'v2/services/help';

import { useStyles } from './styles';
import TicketRow from './TicketRow';

const tableIndexes = [
  { title: 'Ticket', ordering: false },
  { title: 'Título', ordering: false },
  { title: 'Criação', ordering: false },
  { title: 'Última atualização', ordering: false },
  { title: 'Data de solução', ordering: false },
  { title: 'Status', ordering: false },
  { title: '', ordering: false },
];

interface IProps {
  handleNewTicket: () => void;
  handleHistoryClick: (ticketId: number) => void;
}

const MyTickets = ({ handleNewTicket, handleHistoryClick }: IProps) => {
  const classes = useStyles();

  useObservable(() => helpService.loadTickets(), []);
  const [isLoading] = useObservable(() => helpService.getLoadingTickets(), []);
  const [data] = useObservable(() => helpService.getTickets(), []);

  const handleTicketHistoryClick = useCallback((tickedId: number) => handleHistoryClick(tickedId), [handleHistoryClick]);

  return (
    <>
      <Grid container>
        <Grid item xs={6} md={8}>
          <Typography variant='h5'>Meus tickets</Typography>
        </Grid>

        <Grid item xs={6} md={4}>
          <div style={{ textAlign: 'right' }}>
            <PermissionHide action='myeduzz:ajuda:abrir-chamado'>
              <Button variant='contained' color='secondary' onClick={handleNewTicket}>
                <Icon style={{ fontSize: 20, marginRight: 8 }}>add</Icon> Novo Ticket
              </Button>
            </PermissionHide>
          </div>
        </Grid>
      </Grid>

      <div className='m16' />
      <div className={classes.tableContainer}>
        {isLoading && (
          <div style={{ textAlign: 'center', padding: 16 }}>
            <Spin />
            <Typography variant='body1'>Carregando tickets...</Typography>
          </div>
        )}
        {!isLoading && (
          <MyTable responsive={false}>
            <MyTableHeader index={tableIndexes} />
            <MyTableBody>
              {!data?.length && (
                <MyTableRow>
                  <MyTableCol colSpan={7} screenSizes={{ xs: 12, sm: 12 }}>
                    Nenhum registro encontrado
                  </MyTableCol>
                </MyTableRow>
              )}
              {data?.map((ticket) => (
                <TicketRow key={ticket.id} ticket={ticket} handleHistory={handleTicketHistoryClick} />
              ))}
            </MyTableBody>
          </MyTable>
        )}
      </div>
    </>
  );
};

export default MyTickets;
